import styled from 'styled-components';
import { AimOutlined } from '@ant-design/icons';
import { Config } from './config';

export const AimTrainingBox = styled.div`
    background: #222;
    position: relative;
    border-radius: 4px;
    width: ${Config.board.width}px;
    height: ${Config.board.height + Config.scoreboard.height}px;
`;

export const AimBoard = styled.div`
    width: ${Config.board.width}px;
    height: ${Config.board.height}px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CurrentScore = styled.div`
    padding-top: 5px;
`;

export const ScoreBoard = styled.div`
    color: #fff;
    display: flex;
    justify-content: space-between;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 2px;
`;

export const MyAimOutlined = styled(AimOutlined)<{ show: boolean, hide: boolean }>`
    & svg {
        color: #fff;
        ${props => props.show ? `
            transition: width 3s linear;
            width: 100px;
            height: 100px;
        ` : `
            transition: width 1ms linear;
            width: 10px;
            height: 100px;
        `}
        ${props => props.hide && `opacity: 0;`}
    }
`;